
import "./Announcement.css";
import { Link } from "react-router-dom";

const Announcement = () => {
  return (
    <div className="an_sec">
      <div className="hero_img announce_mobile_img">
      <img src="/assets/invertor_relation.jpg" alt="" />

      <div className="hero_title">Announcements</div>

      </div>
      <div className="container2">
        <div className="announcement_div3">
          <div className="announcement_div11">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/assets/announcement/Annual-Return-2021-22.pdf"
              
            >
              <img src="/assets/newsroom/pdf_icon.svg" alt=""  />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/assets/announcement/Annual-Return-2021-22.pdf"
              
              className=""
            >
              Annual Report
            </a>
          </div>
          <div className="announcement_div11">
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/assets/announcement/Notice-of-11th-AGM-CDPL_final.pdf"
              
            >
              <img src="/assets/newsroom/pdf_icon.svg" alt="" />
            </a>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="/assets/announcement/Notice-of-11th-AGM-CDPL_final.pdf"
              
              className=""
            >
              Notice of 11th AGM of CDPL
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Announcement;
